<template>
  <div>
    <b-card>
      <div slot="header">{{ $lang.reportLang.ready_report_access_define }}</div>
      <LoadingSpinner :loading="loading" :text="$lang.sending_data" />
      <b-row v-show="!loading">
        <b-col cols="12" md="12">
          <b-form-group
            :label="`${$lang.reportLang.select_user}: `"
            label-for="user"
            :label-cols="this.$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="`${$lang.reportLang.select_user}: `"
              :rules="$v.user_selected.$params"
            />
            <selectAsync
              :options="user_options"
              v-model="$v.user_selected.$model"
              label="caption"
              :asyncFind="getUserCombo"
              :loading="user_loading"
              :isValid="
                $v.user_selected.$dirty ? !$v.user_selected.$error : null
              "
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.user_selected.$error ? 'block' : 'none',
              }"
              id="user_selected_feedback"
            >
              {{ $lang.error_required | replace($lang.reportLang.select_user) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <b-card no-body class="mb-1">
            <b-card-header
              header-tag="header"
              class="p-0"
              role="tab"
              v-b-toggle="'collapse-select-ready-report'"
            >
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  p-2
                  bg-white
                "
                :class="$v.ready_report_selected.$error ? 'border-danger' : ''"
              >
                <requiredComponent
                  slot="label"
                  :label="`${$lang.reportLang.select_report}: `"
                  :rules="$v.ready_report_selected.$params"
                />
                <i class="fas fa-chevron-down" />
              </div>
              <small
                class="bg-white pb-2 pl-2 text-danger"
                :class="$v.ready_report_selected.$error ? 'd-block' : 'd-none'"
              >
                {{
                  $lang.error_required | replace($lang.reportLang.select_report)
                }}
              </small>
            </b-card-header>
            <b-collapse visible :id="'collapse-select-ready-report'">
              <b-card-body class="p-0 py-3">
                <FilterSearchCheckbox
                  :title="$lang.reportLang.ready_report_table_list"
                  :allowFields="$lang.reportLang.ready_report_table_fields"
                  :url="$config.api_url + $config.report.ready_report_combo"
                  @updateItemsSelected="updateItemsSelected"
                />
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-col>
        <b-col
          cols="12"
          class="text-right mt-3"
          v-if="
            includes('admin', parentPermissions) ||
            includes('edit', parentPermissions)
          "
        >
          <b-button variant="success" @click="submit">
            {{ $lang.submitButton }}
            <i class="fa fa-check"></i>
          </b-button>
          <b-button
            type="reset"
            class="ml-2"
            size="md"
            variant="danger"
            @click="close"
          >
            {{ $lang.close }}
            <i class="fa fa-ban"></i>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { pathOr, includes } from "ramda";
import { required } from "vuelidate/lib/validators";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import FilterSearchCheckbox from "@/components/base/FilterSearchCheckbox.vue";

export default {
  validations: {
    user_selected: { required },
    ready_report_selected: { required },
  },
  components: {
    LoadingSpinner,
    FilterSearchCheckbox,
  },
  props: {
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    operatorFullName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      user_selected: null,
      user_options: [],
      user_loading: false,
      ready_report_selected: null,
      ready_report_options: [],
      ready_report_loading: false,
    };
  },

  methods: {
    pathOr,
    includes,
    close() {
      this.$emit("close");
    },
    async getUserCombo(query) {
      if (!query || query.length < 2) {
        this.user_options = [];
        return;
      }

      try {
        this.user_loading = true;
        const url = `${this.$config.api_url}${this.$config.report.user_combo}?search_txt=${query}`;
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.user_options = data.map((x) => {
          return {
            caption: `${pathOr("", ["name"], x)} - ${pathOr(
              "",
              ["national_code"],
              x
            )}`,
            id: pathOr("", ["code"], x),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.user_loading = false;
      }
    },
    updateItemsSelected(items) {
      this.ready_report_selected = [...items];
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      try {
        this.loading = true;
        const url =
          this.$config.api_url + this.$config.report.ready_report_access;
        const payload = {
          user_code: pathOr(null, ["id"], this.user_selected),
          ready_report_code: this.ready_report_selected,
        };
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.$emit("getData");
        this.close();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
